import React from 'react';
import {
  Box,
  Card,
  Skeleton,
  Divider,
  useTheme,
} from '@ublend-npm/aulaui-core';

export const RecentUpdateCardSkeleton = () => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        borderRadius: 6,
        padding: 2,
        boxShadow: 'none',
        border: `1px solid ${theme.palette.divider}`,
        bgcolor: theme.palette.mode === 'dark' ? '#363636' : '#FFFFFF',
      }}
    >
      <Box mb={2}>
        <Skeleton
          kind="rounded"
          width={110}
          height={24}
          sx={{ borderRadius: '12px' }}
        />
      </Box>

      <Box display="flex" alignItems="center" gap={1.5} mb={2}>
        <Skeleton kind="circular" width={40} height={40} />
        <Box flex={1}>
          <Skeleton kind="text" width={120} height={20} sx={{ mb: 0.5 }} />
          <Skeleton kind="text" width={80} height={16} />
        </Box>
      </Box>

      <Box mb={2}>
        <Skeleton kind="text" width="100%" height={18} sx={{ mb: 1 }} />
        <Skeleton kind="text" width="95%" height={18} sx={{ mb: 1 }} />
        <Skeleton kind="text" width="60%" height={18} />
      </Box>

      <Box display="flex" alignItems="center" gap={3} mb={1.5}>
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton kind="circular" width={20} height={20} />
          <Skeleton kind="text" width={16} height={16} />
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton kind="rounded" width={20} height={20} />
          <Skeleton kind="text" width={16} height={16} />
        </Box>
      </Box>

      <Divider sx={{ my: 1.5, borderColor: theme.palette.divider }} />

      <Box>
        <Skeleton kind="text" width="50%" height={16} />
      </Box>
    </Card>
  );
};

export const RecentUpdatesSkeleton = ({
  orientation,
}: {
  orientation: 'vertical' | 'horizontal';
}) => {
  return (
    <Box
      display="flex"
      flexDirection={orientation === 'vertical' ? 'column' : 'row'}
      gap={2}
    >
      {Array.from({ length: 3 }).map((_, index) => (
        <RecentUpdateCardSkeleton key={index} />
      ))}
    </Box>
  );
};

export default RecentUpdatesSkeleton;
